import { axiosHelper } from 'Services/AxiosHelper';
import { OnCheckPhoneNumberModel } from 'Models';
import { onChangeRegisterCardNickNameBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnChangeRegisterCardNickName';

const onChangeRegisterCardNickName = async (
  params: onChangeRegisterCardNickNameBodyData
): Promise<OnCheckPhoneNumberModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onChangeRegisterCardNickName;
